export default {
    'intel_product': 'インテリジェント設計製品',
    'developing_products': '開発中の製品',
    'typical_cases': '建築構造設計事例集',
    'intelligent_design_preview': 'インテリジェント設計 Labs',
    'HemuNews': '合木ニュース',
    'about_hemu': '合木 AI-structure について',
    'about_us': '私たちについて',
    'language': '言語',
    'sign_up': '登録/ログイン',
    'shearwall_structure': '耐力壁構造',
    'frame_structure': 'ラーメン構造',
    'core_structure': 'ラーメン・コアチューブ構造',
    'structure_intel': '建築構造設計のインテリジェント化',
    'watch_video': 'ビデオを見る',
    'production_and_solution': '製品とソリューション',
    'local_assistant': 'Copilot-local ローカル版インテリジェント設計アシスタント',
    'local_assistant_content': 'AIstructure-CopilotはCADプラットフォームベースの建築構造インテリジェント設計アシスタントです',
    'platform_cloud': 'インテリジェント設計プロジェクト管理プラットフォーム',
    'platform_cloud_content': 'AIstructure Platformはウェブベースのインテリジェント設計・管理プラットフォームです',
    'shearwall_structure_design_title': '耐力壁構造のインテリジェント設計',
    'shearwall_structure_design_content': '独自開発の拡散モデル、GAN、GNNなどの生成AI技術により、建築平面配置図を入力すると、AIが対応する耐力壁・梁構造配置設計、構造部材寸法設計を自動生成し、構造計算と最適化を行います',
    'frame_structure_design_title': 'ラーメン構造のインテリジェント設計',
    'look_forward': '独自開発の拡散モデル、不均質GNNなどの生成AI技術により、建築とラーメン柱平面配置図を入力すると、AIが対応するラーメン梁構造配置設計、梁柱部材寸法設計を自動生成し、ラーメン構造計算を行います',
    'core_structure_design_title': 'ラーメン・コアチューブ構造断面のインテリジェント設計',
    'core_structure_desgin_content': '生成対抗ネットワークなどの生成AI技術により、ラーメン・コアチューブ構造の平面配置図を入力すると、AIが対応する構造部材断面寸法設計を自動生成します',
    'key_competencies_title': 'コア能力',
    'key_component': 'コア能力',
    'key_component_content1': '「データ・力学・知識」結合',
    'key_component_content2': '駆動インテリジェント生成設計アルゴリズム',
    'contact_info': 'お問い合わせ',
    'intellectual_property': '知的財産',
    'patent': '特許',
    'news': 'ニュース',
    'more_news': '更多のニュースを見る',
    'known_more': '詳しく見る',
    'product_problem': '製品に関するお問い合わせ',
    'contact_email': '連絡先メール：',
    'cooperate': 'ビジネス提携',
    'communication_group': 'AI-structure交流グループ',
    'QQ_group': 'QQグループ：',
    'case_number': '备案号：',
    'suggest_chrome': 'より良い体験のためにChromeブラウザのご使用を推奨します',
    'product_download': '製品ダウンロード',
    'intel_product_content1': 'AIstructure-CopilotはCADプラットフォームベースの建築構造インテリジェント設計アシスタントです。',
    'intel_product_content2': 'ローカルコンピュータにAIstructure.exeプログラムをインストールすると、ローカルにインストールされたCADプラットフォーム（Autodesk CADおよび天正CADを推奨）に基づいてCopilotが自動作成されます。AIstructure-Copilotを使用して、ローカルコンピュータのCADプラットフォームで建築構造のインテリジェント設計を実現できます。',
    'intel_platform': 'インテリジェント設計プロジェクト管理',
    'intel_platform_tips': '（代表的な事例の体験版対応、中国語・英語）',
    'sign_in': 'ログイン',
    'instruction': '使用説明',
    'intel_platform_content1': 'インテリジェント設計プロジェクト管理プラットフォームは、耐力壁部材設計、梁・スラブ部材設計、ラーメン・コアチューブ部材設備を備え、アップロードされたデータと建築ピクセル画像をインテリジェントに処理し、構造ピクセル画像を生成して元の建築CADにインポートします。',
    'intel_platform_content2': '現在、耐力壁部材設計の使用を推奨しています。梁・スラブ部材設計、ラーメン・コアチューブ部材設計モジュールはまだ改良・調整中です。お試しください。',
    'automated_rule_interpretation': '仕様自動解釈',
    'automated_rule_interpretation_content1': 'コンピュータが土木工学分野の設計仕様を理解し、自動的にコンピュータコードに翻訳できれば、構造設計のインテリジェント化レベルが大幅に向上します。',
    'automated_rule_interpretation_content2': 'これに対応し、AI仕様自動解釈モジュールを開発しました。ユーザーが自然言語で入力すると、AIが語句の意味を認識し、テキストにタグを付け、テキスト内容を対応する構文木構造に翻訳し、任意のコンピュータ言語のコードに変換できます。',
    'housemind_title': 'HouseMind：建築間取り平面生成・編集プラットフォーム',
    'housemind_web_button': 'プラットフォームに入る',
    'housemind_content1': 'HouseMind：建築間取り平面の「秒級」生成と自然言語対話型編集。',
    'housemind_content2': '間取り配置設計インテリジェントアシスタントは、住宅建築空間の自動分割に特化し、大規模言語モデル（LLM）などの最先端技術を統合し、建築家の間取り配置の深い理解、自動生成、精密編集をサポートします。',
    'housemind_content3': 'ユーザーが提供する建築輪郭と設計要件に基づき、システムは寝室、リビング、キッチン、バスルームなどの機能空間の合理的な配置を自動生成します。また、ユーザーの指示による対話型修正もサポートし、設計者が間取り案を迅速に検討・洗練できるよう支援します。',
    'floorplan_3d_title': 'ChatHouseDiffusion：建築間取り平面生成・3D表示プラットフォーム',
    'floorplan_3d_button': 'プラットフォームに入る',
    'floorplan_3d_content1': 'ChatHouse：建築間取り平面の「分級」正確な生成と3D可視化。',
    'floorplan_3d_content2': 'このプラットフォームは、生成拡散モデル＋最適化アルゴリズムを搭載したインテリジェント建築設計ツールであり、間取り平面生成と3D表示の一体化を実現し、ユーザーの抽象的なニーズを建築物理空間に迅速に変換し、効率的で直感的な建築設計デジタルソリューションを提供します。',
    'floorplan_3d_content3': 'ユーザーは建築輪郭を描き、空間関係を設定するだけで、システムは設定された部屋タイプに基づいて間取り配置とドア・窓設計を自動生成します。全プロセスのリアルタイム対話型微調整をサポートし、ワンクリックで3D没入型プレビューに切り替えられます。',
    'enter_automated': '仕様自動解釈画面に入る',
    'input': '入力',
    'interpretation': '解釈',
    'input_example': '以下の仕様例を入力してみてください：',
    'contact_person': '連絡先：',
    'case_intro': '事例紹介',
    'input_pixel_diagram': '入力ピクセル図',
    'click_to_download_data': 'ベクトルデータをダウンロード',
    'engineer_design_pixel_diagram': '技術者設計ピクセル図',
    'StructGAN_design_pixel_diagram': 'StructGAN設計ピクセル図',
    'StructGAN_design_model': 'StructGAN設計計算モデル',
    'click_download': 'ダウンロード',
    'download': 'ダウンロード',
    'input_data': '入力データ',
    'engineer_design': '技術者設計',
    'StruGAN_design': 'StructGAN設計',
    'company_intro': '会社概要',
    'company_intro_content1': '合木智構は2022年3月に設立され、建設業界の非効率な現状の改善に注力し、土木工学のデジタル化とインテリジェント化を支援しています。',
    'company_intro_content2': '合木智構は、設計図面、設計条件、設計仕様、構造力学などに基づくデータ駆動およびAI for Scienceのインテリジェント設計关键技术を独自開発し、各主要設計要素をカバーする一連の特許を取得し、経験学習と力学分析能力を備えた建築構造生成インテリジェント設計製品を形成しました。',
    'company_intro_efficiency_note': '注：上記の効率向上に関する記載は、公開論文および代表的な事例研究（AIC, 2021, 2022, 2024, 2025; EESD, 2022; JOBE, 2022, 2024; JSE, 2023; SC, 2024）に基づくもので、主に一部の構造方案設計、モデリング、案の比較、最適化などの反復的で自動化可能な工程に適用されます。実際の効果は、プロジェクト種別、入力資料の品質、設計段階、規準要求、技術者による確認プロセスなどにより異なります。',
    'company_intro_content3': '将来、建築工学および新インフラ、交通、エネルギー建設に全く新しい設計パラダイムと生産モデルをもたらします。',
    'hemu_team': '合木チーム',
    'hemu_team_content': '構造設計＋AIエンパワーメント。清華大学土木工学科の教授が主導し、建築分野の著名な専門家と共同で創設し、トップクラスの研究チームと経験豊富な業界チームを形成しています。',
    'history': '発展歴史',
    'basic_info': '基本情報を入力',
    'back_top': 'トップに戻る',
    'contact_now': '今すぐ相談',
    'name': '氏名',
    'input_name': '氏名を入力してください',
    'unit': '所属',
    'input_unit': '所属を入力してください',
    'email': 'メール',
    'input_email': 'メールアドレスを入力してください',
    'contact_phone': '連絡先電話',
    'input_phone': '電話番号を入力してください',
    'question_detail': '質問詳細',
    'input_question_detail': '質問の詳細を入力してください',
    'other_suggestion': 'その他の質問や改善提案',
    'input_suggestion': '提案を入力してください',
    'submit': '送信',
    'reset': 'リセット',
    'product_please_contact': '製品に関するお問い合わせ：',
    'hemu_please_contact': '合木製品/ソリューションにご興味がある場合や、その他の提携をご希望の場合は、ご連絡ください：',
    'name_length_limit': '2〜5文字で入力してください',
    'incorrect_email': 'メール形式が正しくありません',
    'incorrect_phone': '電話番号の形式が正しくありません',
    'initial_page': 'ホーム',
    'main_business': '主な事業',
    'business_content': '合木智構は2022年3月に設立されたテクノロジー企業で、土木工学関連分野向けにデジタル化、インテリジェント化などのサービスを提供しています。',
    'business_content1': '1、カスタマイズ製品導入（プライベートクラウド導入、ローカルサーバー導入サービスを提供可能）',
    'business_content2': '2、カスタム開発（ユーザーのニーズに応じたターゲット開発作業、関連交差分野の生成研究、カスタマイズデータトレーニングなどを含む）',
    'business_content3': '3、共同開発（アップストリーム・ダウンストリームの各産業端と相互接続し、Win-Win協力）',
    'qualifications': '企業資格',
    'awards': '受賞',
    'quality': '革新的中小企業、北京市科学技術型中小企業',
    'quality_national_high_tech': '国家ハイテク企業',
    'coopetration': 'ビジネス提携',
    'wechat': '（WeChat同）',
    'research_process': '研究開発プロセス',
    'qualifications_awards_title': '資格・受賞',
    'profile_title': '会社概要',
    'software_copyrights': 'ソフトウェア著作権',
    'enter_cloud': 'インテリジェント設計プラットフォームに入る',

    // ログイン/登録ページ
    'back_to_main': 'メインページに戻る',
    'hello': 'こんにちは',
    'please_sign_in': 'ログインしてください',
    'click_to_sign_up': 'アカウントをお持ちでない方は登録してください',
    'phone_number': '電話番号',
    'password': 'パスワード',
    'forget_password': 'パスワードを忘れた',
    'sign_in_now': '今すぐログイン',
    'sign_in_by_code': '認証コードでログイン',
    'please_sign_up': '登録へようこそ',
    'account_name': 'ユーザー名（英語）：',
    'enter_english_account_name': '英名を入力してください',
    'chinese_name': '氏名：',
    'enter_chinese_name': '氏名を入力してください',
    'unit_name': '所属名：',
    'enter_unit_name': '所属名を入力してください',
    'enter_phone_number': '電話番号を入力してください',
    'enter_password': 'パスワードを入力してください',
    'confirm_password': 'パスワード確認：',
    'enter_password_again': 'パスワードを再度入力してください',
    'sex': '性別：',
    'male': '男性',
    'female': '女性',
    'phone_code': '電話認証コード：',
    'code': '認証コード',
    'get_code': '認証コードを取得',
    'sign_up_now': '今すぐ登録',
    'account_sign_in_now': 'アカウントをお持ちの方は今すぐログイン',
    'reset_password': 'パスワードリセット',
    'enter_6_code': '6桁の認証コードを入力してください',
    'change_now': '今すぐ変更',
    'back_to_sign_in': 'ログインに戻る',
    'sign_in_by_password': 'パスワードでログイン',
    'login_failed_tips': 'ユーザー、電話番号、またはパスワードの認証に失敗しました。再入力するか管理者に連絡してください',
    'login_success_tips': 'ログイン成功',
    'sign_in_by_phone': '電話で登録',
    'sign_in_by_email': 'メールで登録',
    'email_code': 'メール認証コード',
    'login_phone': '電話ログイン',
    'login_email': 'メールログイン',
    'password_login': 'パスワードログイン',
    'login_number': 'ユーザー名/電話番号/メール',
    'enter_cloud': 'インテリジェント設計プラットフォームに入る',

    // クラウドプラットフォーム
    'intelli_design': 'インテリジェント設計',
    'floorplan_intelligent_design': '建築平面インテリジェント設計',
    'copilot_consultation': 'AIstructure Assistant',
    'copilot_chat_title': 'AIstructure Assistant',
    'copilot_input_placeholder': '質問を入力してください。複数行入力に対応しています',
    'copilot_send': '送信',
    'copilot_thinking': 'AIstructure Assistant が回答を生成中です。しばらくお待ちください...',
    'copilot_request_failed': 'AIstructure Assistant へのリクエストに失敗しました。後でもう一度お試しください',
    'copilot_timeout': 'AIstructure Assistant の応答がタイムアウトしました。後でもう一度お試しください',
    'copilot_empty_state': '質問を入力して相談を開始してください',
    'copilot_empty_input': '相談内容を入力してください',
    'copilot_missing_auth': 'ログイン状態が無効です。再度ログインしてください',
    'change_password': 'パスワード変更',
    'admin_page': '管理者画面',
    'log_out': 'ログアウト',
    'my_project': '建築構造設計プロジェクト',
    'shearwall_design': '耐力壁設計',
    'frame_design': 'ラーメン構造設計',
    'frame_core_desgin': 'ラーメン・コアチューブ設計',
    'cad_plugin': 'CAD前後処理プラグイン',
    'tool_download': 'パラメトリックモデリングツールダウンロード',
    'design': '設計',
    'status': 'ステータス',
    'designed': '設計済み',
    'undesigned': '未設計',
    'delete': '削除',
    'cancel': 'キャンセル',
    'confirm': '確認',
    'project_name': 'プロジェクト名',
    'import_project': 'プロジェクトをインポート',
    'creat_project': 'プロジェクトを作成',
    'remind': 'リマインダー',
    'AIstructure-Copilot': 'AIstructure-Copilot',
    'AIstructure-Copilot_tips': '（ローカルCADプラグイン、中国語・英語）',
    'research_history_title': '研究開発履歴',
    'history_2025_feb_time': '2月21日',
    'history_2025_feb_content': 'AIstructure-Copilot 非直交複雑建築レイアウト設計機能を追加',
    'history_2025_mar_time': '3月14日',
    'history_2025_mar_content': 'AIstructureユーザー設計プロジェクト数が2500件を突破！',
    'history_2025_apr_time': '4月14日',
    'history_2025_apr_content': 'AIstructure-Copilot 複数アルゴリズム統合、新アルゴリズム体験機能を提供',
    'history_2025_may_time': '5月13日',
    'history_2025_may_content': 'AIstructure-Copilot 3メートル階高新国家基準に対応、設計コンプライアンス向上',
    'history_2025_jun1_time': '6月6日',
    'history_2025_jun1_content': 'AIstructure-Copilot-V0.3.6：ラーメン構造インテリジェント設計機能を追加',
    'history_2025_jun2_time': '6月9日',
    'history_2025_jun2_content': '2500→3000！AIstructureユーザー設計プロジェクト数が3000件を突破',
    'history_2025_jul1_time': '7月3日',
    'history_2025_jul1_content': 'AIstructure-Copilot ラーメン構造インテリジェント設計に半架梁と小梁の機能を追加',
    'history_2025_jul2_time': '7月23日',
    'history_2025_jul2_content': 'AIstructure-Copilot 耐力壁インテリジェント設計モジュールが傾斜梁設計機能を改善',
    'history_2025_aug_time': '8月28日',
    'history_2025_aug_content': 'AIstructure-Copilot ラーメン・コアチューブモジュールがワンクリックPKPM/YJKモデルエクスポートを追加',
    'history_2025_sep1_time': '9月11日',
    'history_2025_sep1_content': 'AIでAIを向上、AIstructure-Copilot 前処理が全面的にインテリジェント化アップグレード',
    'history_2025_sep2_time': '9月26日',
    'history_2025_sep2_content': 'AI-structure Copilot 新しいインタラクティブ事例ガイダンス機能',
    'history_2025_oct1_time': '10月27日',
    'history_2025_oct1_content': '3500の実際のプロジェクト！AI-structure Copilotが進歩を加速',
    'history_2025_oct2_time': '10月30日',
    'history_2025_oct2_content': 'AI-structure Copilot 耐力壁設計アルゴリズムが再アップグレード',
    'history_2025_nov_time': '11月20日',
    'history_2025_nov_content': 'AI-structure Copilot がZWCADに対応',
    'history_2025_dec_time': '12月11日',
    'history_2025_dec_content': 'AI-structure Copilot がRevitに対応',
    'history_coming_soon_time': '',
    'history_coming_soon_content': 'お楽しみに',
    'history_2024_jan_time': '1月26日',
    'history_2024_jan_content': 'AIstructure-Copilot インターフェース全面更新、多標準階設計組立を実現',
    'history_2024_feb_time': '2月19日',
    'history_2024_feb_content': 'AIstructure-Copilot 外周軸線自動検出機能を追加',
    'history_2024_mar1_time': '3月8日',
    'history_2024_mar1_content': 'AIstructure-Copilot 梁配置機能を最適化・更新',
    'history_2024_mar2_time': '3月15日',
    'history_2024_mar2_content': 'AIstructure-Copilot 前処理精細化：建築空間認識機能を追加',
    'history_2024_mar3_time': '3月29日',
    'history_2024_mar3_content': 'AIstructure-Copilot エラー通知機能を追加、多標準階設計機能を更新',
    'history_2024_apr_time': '4月19日',
    'history_2024_apr_content': 'AIstructure-Copilot 前処理にレイヤー分離などの機能を追加',
    'history_2024_may1_time': '5月11日',
    'history_2024_may1_content': 'AIstructure-Copilot 設計パフォーマンスが大幅に向上',
    'history_2024_may2_time': '5月20日',
    'history_2024_may2_content': 'AIstructure-Copilot クラウドベースPKPM構造計算とAIstructure最適化機能を追加',
    'history_2024_jun_time': '6月30日',
    'history_2024_jun_content': 'AIstructure-Copilot 部材断面・荷重の表示・修正機能を追加',
    'history_2024_aug_time': '8月30日',
    'history_2024_aug_content': 'AIstructure-Copilot 梁配置設計アルゴリズムを改善',
    'history_2024_sep_time': '9月9日',
    'history_2024_sep_content': 'AIstructure 公式サイト全面アップグレード、英語版を公開',
    'history_2024_oct_time': '10月17日',
    'history_2024_oct_content': 'AIstructure-Copilot 自動レイヤー抽出機能を追加',
    'history_2024_nov_time': '11月4日',
    'history_2024_nov_content': 'AIstructure 二次開発インターフェースAPI試用開始！',
    'history_2024_dec1_time': '12月2日',
    'history_2024_dec1_content': '0→2000！AIstructureユーザー設計プロジェクトが2000件を突破',
    'history_2024_dec2_time': '12月27日',
    'history_2024_dec2_content': 'AIstructure-Copilot ユーザー操作ガイダンス機能を追加',
    'history_2023_feb_time': '2月',
    'history_2023_feb_content': 'ai-structure.com 新年に内部テストを開始',
    'history_2023_mar_time': '3月',
    'history_2023_mar_content': 'ai-structure.com 自動梁設計機能を更新',
    'history_2023_apr_time': '4月',
    'history_2023_apr_content': 'ai-structure.com GNN耐力壁設計機能を追加',
    'history_2023_may_time': '5月',
    'history_2023_may_content': 'ai-structure.com 土木工学仕様AI自動解釈機能を追加',
    'history_2023_jul_time': '7月',
    'history_2023_jul_content': 'AIstructure-Copilot インテリジェント設計アシスタントがオンライン！',
    'history_2023_sep_time': '9月',
    'history_2023_sep_content': 'AIstructure-Copilot 計画設計・モデリング機能を更新',
    'history_2023_oct_time': '10月',
    'history_2023_oct_content': 'AIstructure-Copilot ラーメン・コアチューブ部材断面設計を追加',
    'history_2023_nov_time': '11月',
    'history_2023_nov_content': 'AIstructure-Copilot GAN/GNN/拡散モデルが同時に設計を提供',
    'history_2023_dec_time': '12月',
    'history_2023_dec_content': 'AIstructure-Copilot PKPM/YJK自動モデリング機能を追加'
    ,'team_title': 'チーム'
    ,'iso_certification_title': 'ISO三大マネジメントシステム認証','iso9001': '品質マネジメントシステム認証（ISO 9001）','iso14001': '環境マネジメントシステム認証（ISO 14001）','iso45001': '労働安全衛生マネジメントシステム認証（ISO 45001）'
}
